import { FeatureStatus } from '@/hooks/useFeatures';
import { tokens } from '@/modules/utils/themeUtils';
import {
  Breakpoints,
  styled,
} from '@volkswagen-onehub/components-core';

const backgroundColours = {
  [FeatureStatus.NOT_AVAILABLE]: tokens.globalColors.lightGrey,
  [FeatureStatus.NOT_INCLUDED]: tokens.globalColors.lightGrey,
  [FeatureStatus.STANDARD]: tokens.globalColors.vLightGrey,
  [FeatureStatus.STANDARD_SPEC]: tokens.globalColors.vLightGrey,
  [FeatureStatus.OPTIONAL_EXTRA]: tokens.globalColors.vLightGrey,
  [FeatureStatus.REPLACED]: tokens.globalColors.lightGrey,
};

interface StyledFeatureBox {
  status: FeatureStatus;
}

export const StyledFeatureBox = styled.div<StyledFeatureBox>(
  ({ theme, status }) => `
    background-color: ${backgroundColours[status]};
    opacity: ${status === FeatureStatus.NOT_AVAILABLE ? '0.2' : '1'};
    padding: ${theme.size.static150} ${theme.size.static350};
    border-radius: ${theme.size.static150};
    width: 100%;

    @media (min-width: ${Breakpoints.b960}px) {
      padding: ${theme.size.static200} ${theme.size.static350};
    }
`
);
